import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/free-mode";
import "swiper/css/thumbs";

import "react-phone-input-2/lib/style.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";

import "./Assets/css/style.css";
import "./Assets/css/admin-style.css";
import "./Assets/css/responsive.css";

import AppRoutes from "./Routes/AppRoutes";
import { ToastContainer } from "react-toastify";
import { ReactNode, useEffect } from "react";
import { getLocalData, saveLocalData } from "./utils/LocalStorage";
import { useLoadScript } from "@react-google-maps/api";
import { GOOGLE_API_KEY } from "./utils/env";
import { MAP_LIBRARIES } from "./Constants";

const GoogleMapLoader: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: GOOGLE_API_KEY || "",
    libraries: MAP_LIBRARIES,
  });

  if (isLoaded) {
    return <>{children}</>;
  } else {
    return <div />;
  }
};

function App() {
  const getCurrentLocation = () => {
    const userLocation = getLocalData("userLocation");

    if (!userLocation || userLocation === "") {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const location = JSON.stringify({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            });
            saveLocalData("userLocation", location);
          },
          (err) => {
            console.log(err.message);
          }
        );
      } else {
        console.log("Geolocation is not supported by this browser.");
      }
    }
  };

  useEffect(() => {
    getCurrentLocation();
  }, []);

  return (
    <div className="app-container">
      <GoogleMapLoader>
        <AppRoutes />
      </GoogleMapLoader>

      <ToastContainer />
    </div>
  );
}

export default App;
